export default function* commonSaga() {}
